function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.583,
  width: 17.833,
  height: 17.833,
  rx: 2.675,
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.998 7.043h-1.97v5.918h1.97V7.043zm.126-1.827c-.006-.579-.424-1.02-1.099-1.02-.669 0-1.11.441-1.11 1.02 0 .567.423 1.021 1.086 1.021h.012c.687 0 1.117-.454 1.11-1.02zm2.926 2.668v-.84H8.085s.024.554 0 5.917h1.964V9.657c0-.179.018-.352.066-.483.143-.352.466-.717 1.01-.717.71 0 .996.544.996 1.338v3.165h1.965V9.569c0-1.815-.968-2.663-2.263-2.663-1.047 0-1.514.573-1.774.978z",
  fill: "#fff"
});

function SvgLinkedinBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgLinkedinBlack;